import { ConfigProvider, ThemeConfig } from "antd"

export default function ThemeContext ({ children }: { children: any }) {

    const theme: ThemeConfig = {
        components: {
            Layout: {
                siderBg: "#0000a4",
                footerBg: "#0000a4",
                bodyBg: "#F5F5F5",
                headerBg: "#ffffff"
            }
        },
        token: {
            colorPrimary: '#0000a4',
            colorText: '#000000',
        }
    }

    return (
        <ConfigProvider theme={theme}>
            {children}
        </ConfigProvider>
    )
}